module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edi-my",
    style: ({
      'height': _vm.deviceHeight
    })
  }, [_c('div', {
    staticClass: "edi-my-wrapper"
  }, [_c('div', {
    staticClass: "head fx-festival-background-color"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.logo
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.companyInfo.name))]), _vm._v(" "), _c('h4', [_vm._v("账号: " + _vm._s(_vm.companyInfo.code))])]), _vm._v(" "), _c('ul', {
    staticClass: "ui-listview acc-secure"
  }, [_c('li', [_c('router-link', {
    staticClass: "ui-btn-icon-right ui-icon-carat-r",
    attrs: {
      "to": "/accounts"
    }
  }, [_vm._v("账号安全")])], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "ui-listview"
  }, [_c('li', [_c('router-link', {
    staticClass: "ui-btn-icon-right ui-icon-carat-r",
    attrs: {
      "to": "/infomation"
    }
  }, [_vm._v("企业资料")])], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "ui-listview"
  }, [_c('li', [_c('router-link', {
    staticClass: "ui-btn-icon-right ui-icon-carat-r",
    attrs: {
      "to": "/version"
    }
  }, [_vm._v("版本信息 "), _c('span', [_vm._v("1.0.0")])])], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "ui-listview"
  }, [_c('li', [_c('router-link', {
    staticClass: "ui-btn-icon-right ui-icon-carat-r",
    attrs: {
      "to": "/help"
    }
  }, [_vm._v("帮助")])], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "ui-listview"
  }, [_c('li', [_c('router-link', {
    staticClass: "ui-btn-icon-right ui-icon-carat-r",
    attrs: {
      "to": "/send-info"
    }
  }, [_vm._v("送货信息")])], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "ui-listview"
  }, [_c('li', [_c('router-link', {
    staticClass: "ui-btn-icon-right ui-icon-carat-r",
    attrs: {
      "to": "/paper-manager"
    }
  }, [_vm._v("证照管理")])], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "ui-listview"
  }, [_c('li', [_c('router-link', {
    staticClass: "ui-btn-icon-right ui-icon-carat-r",
    attrs: {
      "to": "/system-parameter"
    }
  }, [_vm._v("系统参数")])], 1)]), _vm._v(" "), _c('fieldset', {
    staticClass: "ui-controlgroup",
    staticStyle: {
      "padding": "0 .5em"
    }
  }, [_c('input', {
    staticClass: "submit fx-festival-btn-color",
    attrs: {
      "type": "submit",
      "value": "退出账号"
    },
    on: {
      "click": _vm.onConfirm
    }
  })])]), _vm._v(" "), _c('tips', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tips),
      expression: "tips"
    }],
    attrs: {
      "btnNum": _vm.btnNum,
      "tipsFont": _vm.tipsFont
    },
    on: {
      "tipStatus": _vm.tipStatus
    }
  }), _vm._v(" "), _c('tips-auto', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsauto),
      expression: "tipsauto"
    }],
    attrs: {
      "tipsFont": _vm.tipsFont
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0235ac81!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/My.vue
// module id = 525
// module chunks = 1